import { createSwitch } from "@gluestack-ui/core/switch/creator";
import { VariantProps, tva, withStyleContext } from "@gluestack-ui/utils";
import React from "react";
import { Switch as RNSwitch } from "react-native";

const UISwitch = createSwitch({
	Root: withStyleContext(RNSwitch),
});

const switchStyle = tva({
	base: "data-[focus=true]:outline-0 data-[focus=true]:ring-2 data-[focus=true]:ring-indicator-primary web:cursor-pointer disabled:cursor-not-allowed data-[disabled=true]:opacity-40 data-[invalid=true]:border-error-700 data-[invalid=true]:rounded-xl data-[invalid=true]:border-2",

	variants: {
		size: {
			sm: "scale-75",
			md: "",
			lg: "scale-125",
		},
	},
});

type ISwitchProps = React.ComponentProps<typeof UISwitch> & VariantProps<typeof switchStyle>;
const Switch = React.forwardRef<React.ComponentRef<typeof UISwitch>, ISwitchProps>(function Switch(
	{ className, size = "md", ...props },
	ref,
) {
	return <UISwitch ref={ref} {...props} className={switchStyle({ size, class: className })} />;
});

Switch.displayName = "Switch";
export { Switch };
